import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Classes from "./pages/Classes";
import Booking from "./pages/Booking";
import Merch from "./pages/Merch";
import Cart from "./pages/Cart";
import PaymentSuccess from "./pages/PaymentSuccess";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Gallery from "./pages/Gallery";
import AdminBookings from "./pages/AdminBookings";
import LoadingScreen from "./components/LoadingScreen";
import { CartProvider } from "./components/CartContext";
import { AddOnsProvider } from "./components/AddOnsContext";

function App() {
  const [booted, setBooted] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setBooted(true), 900);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      {!booted && <LoadingScreen />}
      <CartProvider>
        <AddOnsProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/classes" element={<Classes />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/merch" element={<Merch />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/admin/bookings" element={<AdminBookings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AddOnsProvider>
      </CartProvider>
    </div>
  );
}

export default App;
